import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate} from 'react-router-dom'
import { connect,useDispatch,useSelector } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react';
import { profileSuccess, setToken,getAdminDetails,getIpRegisteryData } from "../reducers/authReducer";
import { getModules } from 'src/reducers/commonReducer';
import {getFeatures} from '../reducers/permissionsReducer';
import OnBoarding from './onboard.component'
import { Layout } from 'antd';
import { AppHeader } from 'src/components';
const { Header, Sider, Content } = Layout;
import SideNavBar from './sidemenuBar';

const DefaultLayout = (props) => {
  const [collapsed, setCollapsed] = useState(false);

  const menuList = useSelector((store)=> store?.permissions?.menuItems);
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const { isAuthenticated, loginWithRedirect, user, getAccessTokenSilently,isLoading } = useAuth0();
    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            dispatch(setToken(token))
            getCustomerDetails()
        } catch (error) {
        }
    };
    const getCustomerDetails = async () => {
        props.getmemeberInformation();
        props.trackauditlogs();
        props.getAdminModules();
    }
    useEffect(()=>{
       if (!isAuthenticated&&!isLoading) {
         loginWithRedirect({redirect_uri: process.env.REACT_APP_REDIRECT_URI});
       } else {
           dispatch(profileSuccess(user))
           callApi()
       }
    },[])
  useEffect(() => {
    const defaultItem = menuList?.find((item) => item?.isEnabled);
    if(defaultItem){navigate(`/${defaultItem?.screenName?.toLowerCase()}`)}
  }, [menuList])
    if (!isAuthenticated || !props.userProfile || !props.deviceToken) {
      return <div className='loader-content'><div className="loader"></div></div>;
    } else if (props.userProfile && !props.userConfig) {
      return <OnBoarding />;
    } else if ((!isAuthenticated) && !window.location.pathname.includes('callback')) {
      return <div className='loader-content'><div className="loader"></div></div>
    }else if(!props.deviceToken){
      return <div className='loader-content'><div className="loader"></div></div>
    }
    const handleSelectedMenu = (item) => {
      setCollapsed(true); 
    };
  return (
    <Layout className='bg-light-layoutBg dark:bg-dark-layoutBg min-h-screen'>
    <Sider
    breakpoint="lg"
    collapsedWidth="0"
    onBreakpoint={(broken) => {
      console.log(broken);
    }}
    collapsible
    collapsed={collapsed}
    onCollapse={(collapsed) => setCollapsed(collapsed)}
    className='sider-width !fixed lg:static z-[9999] lg:z-10 top-[52px] bg-light-layoutBg dark:bg-dark-layoutBg border-r border-r-light-secondaryColor dark:border-r-dark-secondaryColor'

  >
  {props.userProfile.role=="Admin"&&<SideNavBar handleSelectedMenu={handleSelectedMenu}  />}
  </Sider>
  <Layout className='largedev-mr bg-light-layoutBg dark:bg-dark-layoutBg'>
    <Header className='bg-light-layoutBg dark:bg-dark-layoutBg  top-0 z-10 fixed w-full lg:w-full border-b border-b-light-secondaryColor dark:dark:border-b-dark-secondaryColor pl-0 leading-none h-auto max-lg:pr-0'> <AppHeader /></Header>
    <Content className='bg-light-layoutBg dark:bg-dark-layoutBg py-4 pr-4 max-lg:px-3 pt-[72px] z-[9]'><Outlet /></Content>
  </Layout>
</Layout>
  )
}
const connectStateToProps = ({ oidc }) => {
  return { deviceToken: oidc.deviceToken, userProfile: oidc.user,trackauditlogs:oidc.trackauditlogs,userConfig: oidc?.adminDetails  }
}
const connectDispatchToProps = dispatch => {
	return {
	  getmemeberInformation: () => {
		dispatch(getAdminDetails());
	  },
    fetchMenu: (customerId,appid) => {
			dispatch(getFeatures(customerId,appid));
		},
    trackauditlogs: () => {
      dispatch(getIpRegisteryData());
    },
    getAdminModules:()=>{
      dispatch(getModules());
    },
	}
  }
export default connect(connectStateToProps,connectDispatchToProps)(DefaultLayout)
